import Vue from 'vue';
import store from '../store';

export default function useValidationClassesDirective() {
    Vue.directive('validation-classes', {
        bind(el) {
            const _unsubscribe = store.subscribe((mutation, { permitNumberServerValidationError, permitNumberServerValidationErrorMessage }) => {
                if (mutation.type !== 'setPermitNumberServerValidationErrorMessage') {
                    return;
                }

                if (permitNumberServerValidationError) {
                    const $el = $(el);
                    const elName = $el.attr('name');
                    $el.removeClass('valid is-valid').addClass('input-validation-error is-invalid');
                    $el.parents('form:first').find(`[data-valmsg-for="${elName}"]`).html(`<span id="${elName}-error" class="invalid-feedback" style="display: inline;">${permitNumberServerValidationErrorMessage}</span>`);
                }
            });

            el.__permitnumber_unsubscribe__ = _unsubscribe;
        },
        unbind(el) {
            el.__permitnumber_unsubscribe__ && el.__permitnumber_unsubscribe__();
        }
    });
}